export default __webpack_public_path__ + "static/media/TV8.08ed60eb.png";